<ul class="list-unstyled mb-0 d-flex flex-column gap-1" aria-live="polite">
  @for (rule of rules(); track rule.label) {
    <li
      class="d-flex align-items-center gap-2"
      [class.is-met]="rule.met"
      [class.is-missing]="!rule.met"
    >
      <lucide-icon [img]="rule.met ? icons.check : icons.x" [size]="14"></lucide-icon>
      <span>{{ rule.label }}</span>
    </li>
  }
</ul>
